export default "__VITE_ASSET__BwukS9bF__"